export const STR_OBJ_DETAILS_REQUEST = 'STR_OBJ_DETAILS_REQUEST';
export const STR_OBJ_DETAILS_SUCCESS = 'STR_OBJ_DETAILS_SUCCESS';
export const STR_OBJ_DETAILS_FAIL = 'STR_OBJ_DETAILS_FAIL';

